<template>
  <div class="w-full space-y-1" v-if="displayAutomationsSection">
    <div v-if="displayedAutomations?.length" class="space-y-1">
      <CopilotAutomationItem
        v-for="automation in displayedAutomations"
        :key="automation.id"
        :id="automation.id"
        :label="automation.label"
        :labelTranslations="(automation as LightEntity).labelTranslations"
        :type="(automation as LightEntity).type"
        :mimeType="(automation as ExternalContent).mimeType"
        :brain="automation.brain"
        :lang="lang"
        @go-to-content="$emit('go-to-content', automation)"
      />
    </div>
    <div v-if="skeletonCount" class="space-y-1">
      <div
        v-for="i in skeletonCount"
        :key="i"
        class="space-x-2 w-full flex items-center"
      >
        <BaseSkeleton class="size-5 flex-none rounded" />
        <BaseSkeleton class="h-5 flex-1 rounded" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CopilotAutomationItem from './CopilotAutomationItem.vue';
import type { ExternalContent, LightEntity } from '@getmayday/vue-modules';

const props = defineProps<{
  manualAutomationsLoading?: boolean;
  manualAutomations?: (LightEntity | ExternalContent)[];
  lang: string;
}>();

const emit = defineEmits(['go-to-content']);

const displayedAutomations = computed(
  (): ((LightEntity | ExternalContent) & { brain?: boolean })[] => {
    return props.manualAutomations?.length ? props.manualAutomations : [];
  },
);

const skeletonCount = computed(() => {
  return props.manualAutomationsLoading ? 2 : 0;
});

const displayAutomationsSection = computed(
  () => displayedAutomations.value?.length || skeletonCount.value,
);
</script>

<style scoped></style>
